import {graphql} from 'react-apollo';
import gql from 'graphql-tag';

import {SaveProjectMutation, SaveProjectMutationConfig} from '../qql-shared/mutations';
import ProjectForm from '../components/ProjectForm';

const ProjectQuery = gql`
  query project($_id: String!) {
    project(_id: $_id) {
      _id
      name
      key
    }
  }
`;

const ProjectQueryConfig = {
  options: ({match}) => ({variables: {_id: match.params.id}}),
};

export default graphql(SaveProjectMutation, SaveProjectMutationConfig)(
  graphql(ProjectQuery, ProjectQueryConfig)(ProjectForm)
);



// WEBPACK FOOTER //
// ./src/containers/ProjectEdit.js